// The staff app's map: the rail, the palette's Go list and the g-then-letter keys all read this.
export type NavItem = { to: string; label: string; end?: boolean; key?: string; count?: string }
export type NavGroup = { name: string | null; items: NavItem[] }

export const NAV: NavGroup[] = [
  { name: null, items: [{ to: '/staff', label: 'Today', end: true, key: 't', count: 'today' }] },
  { name: 'Pipeline', items: [
    { to: '/staff/pipeline/partners', label: 'Partners', key: 'p' },
    { to: '/staff/pipeline/startups', label: 'Startups', key: 's' },
    { to: '/staff/pipeline/f26', label: 'F26', key: 'f' },
    { to: '/staff/send', label: 'Send', key: 'q', count: 'send' },
    { to: '/staff/calls', label: 'Calls', key: 'l' },
  ] },
  { name: 'Records', items: [
    { to: '/staff/companies', label: 'Companies', key: 'c' },
    { to: '/staff/people', label: 'People', key: 'e' },
  ] },
  { name: 'Numbers', items: [
    { to: '/staff/funnel', label: 'Funnel', key: 'n' },
    { to: '/staff/outreach', label: 'Outreach', key: 'o' },
  ] },
  { name: 'Money', items: [
    { to: '/staff/card', label: 'Card requests', key: 'r', count: 'card' },
    { to: '/staff/payouts', label: 'Payouts', key: 'y', count: 'payouts' },
    { to: '/staff/bills', label: 'Bills', key: 'b' },
    { to: '/staff/partners', label: 'Live partners', key: 'v' },
    { to: '/staff/travel', label: 'Travel', key: 'w' },
    { to: '/staff/fix', label: 'Fixes', key: 'x' },
  ] },
  { name: 'System', items: [
    { to: '/staff/system', label: 'Pipeline health', key: 'h' },
    { to: '/staff/jobs', label: 'Jobs', key: 'j', count: 'jobs' },
    { to: '/staff/log', label: 'Audit log', key: 'a' },
    { to: '/staff/imports', label: 'Imports', key: 'i' },
    { to: '/staff/agent', label: 'Agent access', key: 'g' },
  ] },
]

export const NAV_ITEMS = NAV.flatMap((g) => g.items)
